<template>
    <v-container>
        <!-- <v-dialog v-model="confirmDialog" max-width="500" persistent>
            <v-card>
                <v-card-title style="color: red;">{{ $t('tariffs.confirmDelete') }}</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" dark @click="confirmDelete">{{ $t('button.delete') }}</v-btn>
                    <v-btn color="primary" dark @click="cancelDelete">{{ $t('button.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <merus-data-table :headers="headers" :items="tarifas" :loading="loading" :default-multi-sort="defaultSort"
            :loading-text="$t('tariffs.loadingTariffs')" @update:displayedItems="displayedTariffsItemsForExport = $event"

 cod-tabela="TARIFAS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('tariffs.cadastroTariffs')" :token="token" :items="displayedTariffsItemsForExport !== null ? displayedTariffsItemsForExport : tarifas"
                    :csv-title="$t('tariffs.title')" :pdf-title="$t('tariffs.title')" :pdf-headers="headers" :pdf-filename="$t('tariffs.title')"
                    hide-search>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>{{ title }}</v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="12" md="2">
                                                    <v-text-field v-model="editedItem.cod_tarifa"
                                                        :label="$t('tariffs.headers.code')" />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="2">
                                                    <v-select v-model="editedItem.id_categoria"
                                                        :items="categoriasTarifas" item-text="cod_categoria"
                                                        item-value="id_categoria"
                                                        :label="$t('tariffs.headers.category')" />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="8">
                                                    <v-text-field v-model="editedItem.descricao_tarifa"
                                                        :label="$t('tariffs.headers.description')" />
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dark @click="save">{{ $t('button.save') }}</v-btn>
                                    <v-btn color="primary" dark @click="close">{{ $t('button.cancel') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon color="green" dark small @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <!-- <v-icon color="red" dark small @click="deleteItem(item)">mdi-delete</v-icon> -->
            </template>
        </merus-data-table>

        <merus-data-table :headers="headersTipos" :items="tiposVeiculos" :loading="loadingTipos"
            :default-multi-sort="defaultSortTipos" :loading-text="$t('tariffs.loadingTypesVehicles')" @update:displayedItems="displayedTypesVehiclesItemsForExport = $event"

 cod-tabela="TARIFAS__TIPOS" @update:headers="headersTipos = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('tariffs.typesVehicles')" :token="token" :items="displayedTypesVehiclesItemsForExport !== null ? displayedTypesVehiclesItemsForExport : tiposVeiculos"
                    :csv-title="$t('tariffs.typesVehicles')" :pdf-title="$t('tariffs.typesVehicles')" :pdf-headers="headersTipos"
                    :pdf-filename="$t('tariffs.typesVehicles')" hide-search>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialogTipo" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>{{ titleTipo }}</v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-form ref="formTipo" v-model="formValidadoTipo">
                                            <v-row>
                                                <v-col cols="12" sm="12" md="4">
                                                    <v-text-field v-model="editedItemTipo.descricao_tipo_veiculo"
                                                        :label="$t('tariffs.headers.description')" />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="2">
                                                    <v-switch v-model="editedItemTipo.ar_condicionado"
                                                        :label="$t('tariffs.headers.airConditioning')" />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="2">
                                                    <v-select v-model="editedItemTipo.id_tarifa"
                                                        :items="tarifasVariaveis" item-text="descricao_tarifa"
                                                        item-value="id_tarifa"
                                                        :label="$t('tariffs.headers.tarifaVariable')" />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="2">
                                                    <v-select v-model="editedItemTipo.id_tarifa_fixa"
                                                        :items="tarifasFixas" item-text="descricao_tarifa"
                                                        item-value="id_tarifa"
                                                        :label="$t('tariffs.headers.tarifaFixed')" />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="2">
                                                    <v-select v-model="editedItemTipo.id_tarifa_labor"
                                                        :items="tarifasLabor" item-text="descricao_tarifa"
                                                        item-value="id_tarifa"
                                                        :label="$t('tariffs.headers.tarifaLabor')" />
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dark @click="saveTipo">{{ $t('button.save') }}</v-btn>
                                    <v-btn color="primary" dark @click="closeTipo">{{ $t('button.cancel') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon color="green" dark small @click="editItemTipo(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <!-- <v-icon color="red" dark small @click="deleteItem(item)">mdi-delete</v-icon> -->
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import apiController from '@/utils/apiController';
import EventBus from '../utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import translateDbField from "@/utils/translateDbField";

export default {
    name: 'CRUDTarifas',
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
    headersTipos: [],
        user: null,
        token: null,
        tarifas: [],
        categoriasTarifas: [],
        tiposVeiculos: [],
        loading: false,
        loadingTipos: false,

        editedItem: {
            id_tarifa: null,
            cod_tarifa: null,
            descricao_tarifa: null,
            id_categoria: null
        },
        editedItemTipo: {
            id_tipo_veiculo: null,
            descricao_tipo_veiculo: null,
            ar_condicionado: false,
            id_tarifa: null,
            id_tarifa_fixa: null,
            id_tarifa_labor: null,
            descricao_tarifa_fixa: null,
            descricao_tarifa_labor: null
        },
        // deletedItem: {
        //     id_tarifa: null,
        //     cod_tarifa: null,
        //     descricao_tarifa: null
        // },
        defaultItem: {
            id_tarifa: null,
            cod_tarifa: null,
            descricao_tarifa: null,
            id_categoria: null
        },
        defaultItemTipo: {
            id_tipo_veiculo: null,
            descricao_tipo_veiculo: null,
            ar_condicionado: false,
            id_tarifa: null,
            id_tarifa_fixa: null,
            id_tarifa_labor: null,
            descricao_tarifa_fixa: null,
            descricao_tarifa_labor: null
        },
        dialog: false,
        dialogTipo: false,
        formValidado: false,
        formValidadoTipo: false,
        displayedTypesVehiclesItemsForExport: null,
        displayedTariffsItemsForExport: null,
        confirmDialog: false,
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            if (this.$refs.formTipo) {
                this.$refs.formTipo.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.populaRecursos();
    },
    computed: {
        title() {
            return this.editedItem.id_tarifa ? this.$t('tariffs.edit') : this.$t('tariffs.new');
        },
        titleTipo() {
            return this.editedItemTipo.id_tipo_veiculo ? this.$t('tariffs.editType') : this.$t('tariffs.newType');
        },
        tarifasFixas() {
            return this.tarifas.filter(tarifa => tarifa.id_categoria === 1);
        },
        tarifasVariaveis() {
            return this.tarifas.filter(tarifa => tarifa.id_categoria === 2);
        },
        tarifasLabor() {
            return this.tarifas.filter(tarifa => tarifa.id_categoria === 3);
        },
    defaultSortTipos() {
            return [
                { value: 'descricao_tipo_veiculo', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
        },
        defaultSort() {
            return [
                { value: 'cod_tarifa', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
        },
    },
    methods: {

        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatetarifa");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/inserttarifa");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletetarifa");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            this.populaTarifas();
            this.populaTiposVeiculos();
            this.populaCategoriasTarifas();
        },
        async populaTarifas() {
            this.loading = true;
            try {
                const response = await apiController.request(apiController.endpoints.getallTipostarifas, { silent: true });

                if (response.data && response.data.error) {
                    EventBus.$emit('show-error', { error: response.data.error });
                    return;
                }
                this.tarifas = Array.isArray(response.data) ? response.data : [];
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.loading = false;
            }
        },
        async populaTiposVeiculos() {
            this.loadingTipos = true;
            try {
                const response = await apiController.request(apiController.endpoints.getallTiposveiculos, { silent: true });

                if (response.data.error) {
                    EventBus.$emit('show-error', { error: response.data.error });
                    return;
                }

                this.tiposVeiculos = response.data.map(tipoVeiculo => {
                    const translated = translateDbField(
                        tipoVeiculo.translation_key,
                        tipoVeiculo.descricao_tipo_veiculo
                    );
                    const arCondicionado = Number(tipoVeiculo.ar_condicionado) === 1;
                    return {
                        ...tipoVeiculo,
                        descricao_tipo_veiculo: translated,
                        ar_condicionado: arCondicionado,
                        ar_condicionado_extenso: arCondicionado ? this.$t('system.yes') : this.$t('system.no')
                    };
                });
                this.loadingTipos = false;
            } catch (e) {
                this.loadingTipos = false;
                EventBus.$emit('show-error', { error: e });
            }
        },
        async populaCategoriasTarifas() {
            try {
                const response = await apiController.request(apiController.endpoints.getallCategoriastarifas, { silent: true });

                if (response.data.error) {
                    EventBus.$emit('show-error', { error: response.data.error });
                    return;
                }

                this.categoriasTarifas = response.data.map(categoria => {
                    const translated = translateDbField(
                        categoria.translation_key,
                        categoria.cod_categoria
                    );
                    return {
                        ...categoria,
                        cod_categoria: translated
                    };
                });
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            }
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.$refs.form.resetValidation();
            });
        },
        closeTipo() {
            this.dialogTipo = false;
            this.$nextTick(() => {
                this.editedItemTipo = Object.assign({}, this.defaultItemTipo);
                this.$refs.formTipo.resetValidation();
            });
        },
        save() {
            if (this.$refs.form.validate()) {
                if (this.editedItem.id_tarifa) {
                    this.updateTarifa();
                } else {
                    this.insertTarifa();
                }
            }
        },
        saveTipo() {
            if (this.$refs.formTipo.validate()) {
                if (this.editedItemTipo.id_tipo_veiculo) {
                    this.updateTipo();
                } else {
                    this.insertTipo();
                }
            }
        },
        async updateTarifa() {
            try {
                const response = await apiController.request(apiController.endpoints.updateTipotarifa, { data: this.editedItem, silent: true });

                if (response.data.error) {
                    EventBus.$emit('show-error', { error: response.data.error });
                    return;
                }

                this.close();
                this.populaTarifas();
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            }
        },
        async updateTipo() {
            try {
                const response = await apiController.request(apiController.endpoints.updateTipoveiculo, { data: this.editedItemTipo, silent: true });

                if (response.data.error) {
                    EventBus.$emit('show-error', { error: response.data.error });
                    return;
                }

                this.closeTipo();
                this.populaTiposVeiculos();
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            }
        },
        async insertTarifa() {
            try {
                const response = await apiController.request(apiController.endpoints.insertTipotarifa, { data: this.editedItem, silent: true });

                if (response.data.error) {
                    EventBus.$emit('show-error', { error: response.data.error });
                    return;
                }

                this.close();
                this.populaTarifas();
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            }
        },
        async insertTipo() {
            try {
                const response = await apiController.request(apiController.endpoints.insertTipoveiculo, { data: this.editedItemTipo, silent: true });

                if (response.data.error) {
                    EventBus.$emit('show-error', { error: response.data.error });
                    return;
                }

                this.closeTipo();
                this.populaTiposVeiculos();
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            }
        },
        editItem(item) {
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        editItemTipo(item) {
            this.editedItemTipo = Object.assign({}, item);
            this.dialogTipo = true;
        },
        // deleteItem(item) {
        //     this.deletedItem = Object.assign({}, item);
        //     this.confirmDialog = true;
        // },
        // async confirmDelete() {
        //     const response = await axios.post(`${ApiBaseUrl}/api/v1.0/deletetipotarifa`, this.deletedItem, {
        //         headers: {
        //             'x-access-token': this.token
        //         }
        //     });

        //     if (response.data.error) {
        //         this.erro = response.data.error;
        //         this.$refs.erroSistema.show();
        //         return;
        //     }

        //     this.confirmDialog = false;
        //     this.deletedItem = Object.assign({}, this.defaultItem);
        //     this.populaTarifas();
        // },
        // cancelDelete() {
        //     this.confirmDialog = false;
        //     this.deletedItem = Object.assign({}, this.defaultItem);
        // },
    }
}
</script>